import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createIcon } from "@chakra-ui/react/icon";
export default createIcon({
    displayName: "Calendar",
    viewBox: "0 0 24 24",
    path: (_jsxs(_Fragment, { children: [_jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }), _jsx("path", { d: "M7 2C6.448 2 6 2.448 6 3V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V3C18 2.448 17.552 2 17 2C16.448 2 16 2.448 16 3V4H8V3C8 2.448 7.552 2 7 2ZM5 9H19V19C19 19.552 18.552 20 18 20H6C5.448 20 5 19.552 5 19V9Z", fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor" })] })),
});
